module.exports = __webpack_public_path__ + "static/media/Trade Gothic L-01.3f3acf86.svg";